<div class="filter-sort-form" *ngIf="model && model.filterBy">
  <div class="d-flex flex-wrap justify-content-between">
    <rr-radio-button-field
      [(ngModel)]="model.filterBy.value"
      [settings]="radiobuttonFieldSettings"
      [options]="options"
      (ngModelChange)="onRadiobuttonFieldChange($event)"
    >
    </rr-radio-button-field>
  </div>
</div>
